import React from 'react';
import { Row, Col, Button, Icon } from 'antd';

import ProfileStats from '../ProfileStats';
import ProfileSection from '../ProfileSection';

const ProfileContent = ({ user, currentUser, chatId, params, handleOpenChat }) => {
  const data = [
    {
      title: 'Subscribers',
      numbers: '0'
    },
    {
      title: 'Subscripions',
      numbers: '0'
    },
    {
      title: 'Channels',
      numbers: '0'
    }
  ];

  return (
    <Row className="profile" type="flex" gutter={18}>
      <Col xs={24} md={17}>
        <ProfileSection 
          data={user}
          additionalContent={
            <div className="profile-button">
              <Button
                type="primary"
                onClick={() => handleOpenChat(chatId)}
                disabled={currentUser && currentUser.uid === params.profileId}
              >
                <Icon type="message" />
                Send Message
              </Button>
            </div>
          } 
        />
      </Col>
      <Col xs={24} md={7}>
        <ProfileStats 
          data={data}
          type="userProfile"
        />
      </Col>
    </Row>
  )
}

export default ProfileContent;


// WEBPACK FOOTER //
// ./src/components/Modules/ProfileContent/index.js